export default __webpack_public_path__ + "img/hourBack-08f4ce70.png";